export default __webpack_public_path__ + "static/media/AcuteStrokev1.2HASs+s.1d270408.jpg";